var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0228 10.9545H15.9773C13.1646 10.9545 10.9546 13.1645 10.9546 15.9773V26.0227C10.9546 28.8354 13.1646 31.0454 15.9773 31.0454H26.0228C28.8355 31.0454 31.0455 28.8354 31.0455 26.0227V15.9773C31.0455 13.1645 28.8355 10.9545 26.0228 10.9545ZM29.0364 26.0227C29.0364 27.7304 27.7305 29.0363 26.0228 29.0363H15.9773C14.2696 29.0363 12.9637 27.7304 12.9637 26.0227V15.9773C12.9637 14.2695 14.2696 12.9636 15.9773 12.9636H26.0228C27.7305 12.9636 29.0364 14.2695 29.0364 15.9773V26.0227Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 15.9773C18.1871 15.9773 15.9771 18.1873 15.9771 21C15.9771 23.8128 18.1871 26.0228 20.9998 26.0228C23.8125 26.0228 26.0225 23.8128 26.0225 21C26.0225 18.1873 23.8125 15.9773 20.9998 15.9773ZM20.9998 24.0137C19.2921 24.0137 17.9861 22.7078 17.9861 21C17.9861 19.2923 19.2921 17.9864 20.9998 17.9864C22.7075 17.9864 24.0134 19.2923 24.0134 21C24.0134 22.7078 22.7075 24.0137 20.9998 24.0137Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0221 16.9818C26.5769 16.9818 27.0267 16.5321 27.0267 15.9773C27.0267 15.4225 26.5769 14.9727 26.0221 14.9727C25.4673 14.9727 25.0176 15.4225 25.0176 15.9773C25.0176 16.5321 25.4673 16.9818 26.0221 16.9818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/Instagram-icon.5ae7bb63d23812417bc940d3135c4fdd.svg";
export { ForwardRef as ReactComponent };